import { combineReducers } from "redux"
// import { persistReducer } from "redux-persist";
// import storage from "redux-persist/lib/storage";

import homePageReducer from "./homePage/homePage.reducer"
import adminReducer from "./admin/admin.reducer"
import collegeReducer from "./college/college.reducer"

import RootActionTypes from "./root.types"
//the configuration of the persistor
// const persistConfig = {
//   key: "root",
//   storage,
// the array contains the reducer that we want to store
//   whitelist: ["user"],
// };

const appReducer = combineReducers({
  user: homePageReducer,
  admin: adminReducer,
  college: collegeReducer
});

const rootReducer = ( state, action ) => {
 if ( action.type === RootActionTypes.LOGOUT ) {
   state = {
      user: {
        user: null
      },
      admin: {
        teacher: null,
        all_users: [],
        all_custs: [],
      },
      college: {
        user: {},
        permissions: {},
        institution: {},
        campuses: [],
        personnel: [],
        classes: []
      }
   };
 }
     
 return appReducer(state, action)
}

export default rootReducer

// const rootReducer = combineReducers({
//   user: homePageReducer,
//   admin: adminReducer,
//   college: collegeReducer
// })